@let pickedIds = pickedService.pickedIds$ | async;
<div class="picked-users-container">
  @if (pickedIds?.length) {
    <ul class="entity-list">
      @for (id of pickedIds; track identityFunction(id)) {
        <li
          class="entity-list__item"
          [class.entity-list__item--current-user]="id === userId"
          [pluginsAnimation]="animations"
        >
          <plugins-user-entity
            *pluginsLet="pickedService.pickedEntities$ | async as entities"
            [ngStyle]="{ height: calculatedSizes().listItem }"
            [size]="size()"
            [userProvider]="entities?.get(id)"
            [showTitle]="true"
            [detailedTitle]="detailedTitle()"
            [profileLinkEnabled]="profileLinksEnabled()"
          >
            @if (entities?.get(id)?.type !== 'error' && showDelete()) {
              <plugins-shared-button
                size="sm"
                variant="secondary-text"
                [disabled]="disabled()"
                [ariaLabel]="labels.buttonAriaLabel | translate"
                (clicked)="removeUser(id)"
              >
                <icon-cancel />
              </plugins-shared-button>
            }
          </plugins-user-entity>
        </li>
      }
    </ul>
  } @else {
    @let placeholder = placeholders();
    @if (placeholder.text) {
      <p class="placeholder-text">
        {{ placeholder.text }}
      </p>
    }
    @if (placeholder.template) {
      <div class="placeholder-template-container">
        <ng-container *ngTemplateOutlet="placeholder.template" />
      </div>
    }
  }
</div>
